var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarTodayFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.2 22q-.824 0-1.413-.587A1.93 1.93 0 0 1 3.2 20V6q0-.824.587-1.412A1.93 1.93 0 0 1 5.2 4h1V3q0-.424.287-.712A.97.97 0 0 1 7.2 2q.424 0 .712.288.288.287.288.712v1h8V3q0-.424.288-.712A.97.97 0 0 1 17.2 2q.424 0 .713.288.287.287.287.712v1h1q.824 0 1.413.588.587.587.587 1.412v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19.2 22zm0-2h14V10h-14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTodayFill);
export default __webpack_public_path__ + "static/media/calendar_today_fill.9876e9ad50a89945e00c05c9ee8c02e7.svg";
export { ForwardRef as ReactComponent };